import React, { useState } from "react";
import { toast } from "react-toastify";
import arrowLeft from "../assets/images/navbar/arrow-left.png";
import cancel from "../assets/images/navbar/cancel.png";
import { restaurantService } from "../services";
import { useRestaurant } from "../context/RestaurantContext";

type SheduleOffKitchenProps = {
  setIsSheduleOffKitchenOpen: (open: boolean) => void;
};

type ReasonType =
  | "renovation"
  | "festival"
  | "permanent"
  | "staff"
  | "outOfStation"
  | "other"
  | null;

const SheduleOffKitchen = ({
  setIsSheduleOffKitchenOpen,
}: SheduleOffKitchenProps) => {
  const { setIsRestaurantOpen, refreshProfile } = useRestaurant();
  const [selectedReason, setSelectedReason] = useState<ReasonType>(null);
  const [autoOpen, setAutoOpen] = useState<"none" | "2_hours" | "4_hours" | "tomorrow_first_slot">("tomorrow_first_slot");
  const [saving, setSaving] = useState(false);

  const reasons = [
    { id: "renovation", label: "Renovation or relocation", icon: "🔧" },
    { id: "festival", label: "Closed due to Festival", icon: "🎉" },
    { id: "permanent", label: "Permanent Shut", icon: "🔒" },
    { id: "staff", label: "Staff availability issues", icon: "👥" },
    { id: "outOfStation", label: "Going out of station", icon: "🚗" },
    { id: "other", label: "Other", icon: "📝" },
  ];

  const handleScheduleOffKitchen = async () => {
    if (!selectedReason) return;
    setSaving(true);
    try {
      await restaurantService.toggleRestaurantStatus(false);
      if (selectedReason !== "permanent" && autoOpen !== "none") {
        await restaurantService.scheduleAutoOpen({ type: autoOpen });
      }
      localStorage.setItem(
        "kitchenScheduleOffReason",
        JSON.stringify({ reason: selectedReason, at: new Date().toISOString() })
      );
      setIsRestaurantOpen(false);
      await refreshProfile();
      toast.success("Kitchen scheduled off successfully");
      setIsSheduleOffKitchenOpen(false);
    } catch (error: any) {
      toast.error(error?.message || "Failed to schedule kitchen off");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 z-[60]"
      onClick={() => setIsSheduleOffKitchenOpen(false)}
    >
      <div
        className="fixed right-0 top-0 h-full w-full max-w-[450px] bg-white dark:bg-gray-900 rounded-l-[20px] overflow-y-auto flex flex-col"
        style={{ animation: "slideInRight 0.3s ease-out" }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="w-full p-6 flex-1">
          <div className="w-full flex justify-between items-center mb-6">
            <div className="flex items-center gap-4">
              <img
                src={arrowLeft}
                alt="back"
                className="w-[36px] h-[36px] rounded-full border cursor-pointer p-2"
                onClick={() => setIsSheduleOffKitchenOpen(false)}
              />
              <h1 className="text-[#040404] dark:text-gray-200 font-Urbanist text-[20px] font-semibold">
                Schedule off Kitchen
              </h1>
            </div>
            <img
              src={cancel}
              alt="close"
              className="w-[36px] h-[36px] p-2 rounded-full border cursor-pointer"
              onClick={() => setIsSheduleOffKitchenOpen(false)}
            />
          </div>

          <div className="w-full space-y-0 flex-1">
            {reasons.map((reason, index) => (
              <div
                key={reason.id}
                className={`flex justify-between items-center py-4 cursor-pointer ${
                  index !== reasons.length - 1 ? "border-b border-gray-200 dark:border-gray-700" : ""
                }`}
                onClick={() => setSelectedReason(reason.id as ReasonType)}
              >
                <div className="flex items-center gap-3">
                  <span className="text-[20px]">{reason.icon}</span>
                  <span className="text-[#040404] dark:text-gray-200 font-Urbanist text-[16px]">
                    {reason.label}
                  </span>
                </div>
                <div className="flex items-center justify-center w-[24px] h-[24px] rounded-full border-2 border-gray-300">
                  {selectedReason === reason.id && (
                    <div className="w-[14px] h-[14px] rounded-full bg-[#F30]"></div>
                  )}
                </div>
              </div>
            ))}
          </div>

          {selectedReason && selectedReason !== "permanent" && (
            <div className="mt-6">
              <p className="text-sm font-medium mb-2 dark:text-gray-200">Auto open again</p>
              <select
                className="w-full px-4 py-3 rounded-lg border dark:bg-gray-800 dark:text-gray-200"
                value={autoOpen}
                onChange={(e) => setAutoOpen(e.target.value as typeof autoOpen)}
              >
                <option value="2_hours">In 2 hours</option>
                <option value="4_hours">In 4 hours</option>
                <option value="tomorrow_first_slot">Tomorrow first slot</option>
                <option value="none">Keep closed</option>
              </select>
            </div>
          )}
        </div>

        <div className="w-full p-6 pt-0">
          <button
            onClick={handleScheduleOffKitchen}
            disabled={!selectedReason || saving}
            className="w-full py-4 text-white font-Urbanist text-[16px] font-semibold disabled:opacity-50"
            style={{ borderRadius: "150px", background: "#F30" }}
          >
            {saving ? "Scheduling..." : "Schedule Off Kitchen"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SheduleOffKitchen;
